(function () {
  if (window.__pfValidateLoaded) return;
  window.__pfValidateLoaded = true;

  var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function setInvalid(field, msg) {
    field.classList.add('is-invalid');
    var slot = field.querySelector('[data-pf-error-msg]');
    if (slot) slot.textContent = msg || '';
  }

  function clearInvalid(field) {
    field.classList.remove('is-invalid');
    var slot = field.querySelector('[data-pf-error-msg]');
    if (slot) slot.textContent = '';
  }

  function validateField(input) {
    var field = input.closest('.pf-field');
    if (!field) return true;
    var msg = input.getAttribute('data-pf-error') || 'Please fill out this field correctly.';
    var val = (input.value || '').trim();

    if (input.required && !val) {
      setInvalid(field, msg);
      return false;
    }
    if (input.type === 'email' && val && !emailRe.test(val)) {
      setInvalid(field, 'Please enter a valid email address.');
      return false;
    }
    if (input.type === 'tel' && val) {
      var digits = val.replace(/\D/g, '');
      if (digits.length < 7) {
        setInvalid(field, 'Please enter a valid phone number.');
        return false;
      }
    }
    if (input.pattern && val) {
      try {
        var re = new RegExp('^(?:' + input.pattern + ')$');
        if (!re.test(val)) {
          setInvalid(field, msg);
          return false;
        }
      } catch (e) {}
    }
    clearInvalid(field);
    return true;
  }

  function initWrap(wrap) {
    if (wrap.dataset.pfInit) return;
    wrap.dataset.pfInit = '1';
    var form = wrap.querySelector('form');
    if (!form) return;
    form.setAttribute('novalidate', 'novalidate');
    var loadedAt = Date.now();
    var minMs = (parseInt(wrap.getAttribute('data-pf-min-time'), 10) || 0) * 1000;

    form.querySelectorAll('input, select, textarea').forEach(function (el) {
      if (el.type === 'hidden' || el.hasAttribute('data-pf-honeypot')) return;
      el.addEventListener('blur', function () { validateField(el); });
      el.addEventListener('input', function () {
        var f = el.closest('.pf-field');
        if (f && f.classList.contains('is-invalid')) validateField(el);
      });
    });

    form.addEventListener('submit', function (e) {
      var fieldCount = form.querySelectorAll('.pf-field').length;
      if (fieldCount === 0) {
        e.preventDefault();
        return;
      }

      var hp = form.querySelector('[data-pf-honeypot]');
      if (hp && hp.value.trim() !== '') {
        e.preventDefault();
        return;
      }
      if (minMs > 0 && Date.now() - loadedAt < minMs) {
        e.preventDefault();
        var first = form.querySelector('.pf-field');
        if (first) setInvalid(first, 'Please take a moment to fill out the form.');
        return;
      }
      var ok = true;
      var firstInvalid = null;
      form.querySelectorAll('input, select, textarea').forEach(function (el) {
        if (el.type === 'hidden' || el.hasAttribute('data-pf-honeypot')) return;
        if (!validateField(el)) {
          ok = false;
          if (!firstInvalid) firstInvalid = el;
        }
      });
      if (!ok) {
        e.preventDefault();
        if (firstInvalid) firstInvalid.focus();
        return;
      }
      var btn = form.querySelector('.pf-btn');
      if (btn) {
        btn.disabled = true;
        btn.dataset.originalText = btn.textContent;
        btn.textContent = 'Submitting…';
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pf-form-wrap]').forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pf-success-redirect]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-pf-success-redirect') || '/';
    window.location.href = url;
  });
})();
